import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SolidPinFill",
  "use": "SolidPinFill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"SolidPinFill\"><path d=\"M13.707 4.293A1 1 0 0012 5v1.65L8.52 11H6a1 1 0 00-.707 1.707L7.586 15l-3.293 3.293a1 1 0 101.414 1.414L9 16.414l2.293 2.293A1 1 0 0013 18v-2.52L17.35 12H19a1 1 0 00.707-1.707l-6-6z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol